import { Tooltip } from '@repo/ui';
import { PROFILE_TYPE } from 'domain/value-objects/profile-type';
import FeatherIcon from 'feather-icons-react';
import { Input, Label, Table } from 'reactstrap';

export interface PersonProfile {
  id: number;
  name: string;
  roleId: number;
  isActive?: boolean;
  course: {
    id: string | number;
    name: string;
  };
  entity: {
    id: string | number;
    name: string;
  };
}

interface IPersonProfilesTableProps {
  data: PersonProfile[];
  handleActiveInactiveSwitchChange: (
    profileId: number,
    checked: boolean,
  ) => void;
}

export const PersonProfilesTable = ({
  data,
  handleActiveInactiveSwitchChange,
}: IPersonProfilesTableProps) => {
  const handleRedirect = (item: PersonProfile) => {
    const path =
      item.roleId === PROFILE_TYPE.DIRECTOR ? 'gestor' : 'organizacao';

    window.open(`/impersonate/${path}/${item.id}`, '_self');
  };

  return (
    <div className="table-responsive mt-4 mt-xl-0">
      <Table className="table-borderless table-hover align-middle table-nowrap mb-0">
        <thead>
          <tr>
            <th scope="col">Organização</th>
            <th scope="col">Curso</th>
            <th scope="col">Perfil</th>
            <th scope="col"> </th>
            <th scope="col"> </th>
          </tr>
        </thead>
        <tbody>
          {(data || []).map((item) => (
            <tr key={item.id}>
              <td className="fw-medium">{item.entity.name}</td>
              <td>{item.course.name}</td>
              <td>{item.name}</td>
              <td>
                <div className="form-check form-switch form-switch-success">
                  <Label
                    className="form-check-label"
                    htmlFor={`SwitchCheck-${item.id}`}
                  >
                    {item.isActive ? 'Ativo' : 'Inativo'}
                  </Label>
                  <Input
                    className="form-check-input  ms-2"
                    type="checkbox"
                    role="switch"
                    id={`SwitchCheck-${item.id}`}
                    checked={item.isActive}
                    onChange={(e) =>
                      handleActiveInactiveSwitchChange(
                        item.id,
                        e.target.checked,
                      )
                    }
                  />
                </div>
              </td>

              <td>
                {item.isActive && item.roleId !== PROFILE_TYPE.STUDENT && (
                  <>
                    <div
                      id={`impersonate-${item.id}`}
                      className="cursor-pointer"
                      onClick={() => handleRedirect(item)}
                    >
                      <FeatherIcon icon="lock" size={18} />
                    </div>

                    <Tooltip
                      targetId={`impersonate-${item.id}`}
                      text="Acessar como este usuário"
                    />
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};
